import React, {Component} from 'react';
import PropTypes from 'prop-types';
import update from 'immutability-helper';
import ProductStepper from './ProductStepper';
import ProductHeader from './ProductHeader';
import ProductCardGroup from './ProductCardGroup';

import words from '../data/words';

class ProductsOverlay extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeStep: 'WORDS', // WORDS
      filters: {
        words: {
          pattern: [],
        },
      },
    };
  }

  handleClickStep = (stepName) => {
    this.setState({
      activeStep: stepName,
    });
  };

  handleClickActionBtn = (productId, model) => {
    this.props.onClickActionBtn(productId, model);
  };

  handleRemoveFilter = (filter) => {
    this.setState(
      update(this.state, {
        filters: {
          [filter.product]: {
            [filter.attr]: {
              $set: this.state.filters[filter.product][filter.attr].filter((val) => val !== filter.value),
            },
          },
        },
      }),
    );
  };

  applyFilter(toFilter, filters, filterKey) {
    const filtered = JSON.parse(JSON.stringify(toFilter));
    Object.keys(toFilter).forEach((key) => {
      const item = toFilter[key];
      if (filters[filterKey].length && !filters[filterKey].includes(item[filterKey])) {
        delete filtered[key];
      }
    });
    return filtered;
  }

  handleSetFilters = (product, attr, filters) => {
    this.setState(
      update(this.state, {
        filters: {
          [product]: {
            [attr]: {
              $set: filters,
            },
          },
        },
      }),
    );
  };

  renderCardGroup() {
    const activeStep = this.state.activeStep;
    const cardGroupProps = {
      onClickActionBtn: this.handleClickActionBtn,
    };

    if (activeStep === 'WORDS') {
      return (
        <ProductCardGroup
          products={this.applyFilter(words, this.state.filters.words, 'pattern')}
          {...cardGroupProps}
        />
      );
    }
  }

  render() {
    const {activeStep} = this.state;

    return (
      <div className="products-overlay disable-dbl-tap-zoom">
        <ProductStepper
          onClickStep={this.handleClickStep}
          onClickClose={this.props.onClickClose}
          activeStep={activeStep}
        />

        <ProductHeader
          activeStep={activeStep}
          filters={this.state.filters}
          removeFilter={this.handleRemoveFilter}
          setFilter={this.handleSetFilters}
        />

        {this.renderCardGroup()}
      </div>
    );
  }
}

ProductsOverlay.propTypes = {
  onClickClose: PropTypes.func.isRequired,
  onClickActionBtn: PropTypes.func.isRequired,
};

export default ProductsOverlay;
